package cz.lhoracek.mapl.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SnackbarDuration
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import mapl.composeapp.generated.resources.Res
import mapl.composeapp.generated.resources.delete
import mapl.composeapp.generated.resources.ic_delete
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun UndoDeleteSnackbarEffect(
    trigger: Any?,
    enabled: Boolean,
    snackbarHostState: SnackbarHostState,
    message: String,
    actionLabel: String,
    onUndo: () -> Unit,
    onDismissed: () -> Unit = {},
    dismissCurrentBeforeShowing: Boolean = false,
) {
    LaunchedEffect(trigger) {
        if (!enabled) return@LaunchedEffect
        if (dismissCurrentBeforeShowing) {
            snackbarHostState.currentSnackbarData?.dismiss()
        }
        val result = snackbarHostState.showSnackbar(
            message = message,
            actionLabel = actionLabel,
            duration = SnackbarDuration.Short,
        )
        if (result == SnackbarResult.ActionPerformed) {
            onUndo()
        } else {
            onDismissed()
        }
    }
}

@Composable
fun CommitPendingDeleteOnDispose(onCommitDelete: () -> Unit) {
    DisposableEffect(Unit) {
        onDispose(onCommitDelete)
    }
}

@Composable
fun DeleteDismissBackground(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier
            .fillMaxSize()
            .background(MaterialTheme.colorScheme.errorContainer)
            .padding(end = 20.dp),
        contentAlignment = Alignment.CenterEnd,
    ) {
        Icon(
            painter = painterResource(Res.drawable.ic_delete),
            contentDescription = stringResource(Res.string.delete),
            tint = MaterialTheme.colorScheme.onErrorContainer,
        )
    }
}
